import { Grid } from '@mui/material';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { StyledSliderInput } from '../../styled/slider.input';

export const SliderInput = ({
  field,
  design,
  urlValue,
  onChange,
  value,
  focus,
}: any) => {
  const { t } = useTranslation();

  // let initialValue = undefined;

  // if (field.defaultValue) {
  //   try {
  //     initialValue = parseValue(field.defaultValue);
  //   } catch (e) {
  //     console.log('invalid default value', e);
  //   }
  // }

  // if (urlValue) {
  //   initialValue = parseUrlValue(urlValue);
  // }

  return (
    <Grid>
      <StyledSliderInput
        design={design}
        onChange={onChange}
        value={value}
        name={field.id}
        id={field.id}
        field={field}
      />
    </Grid>
  );
};
